import { DotsThreeVertical, Envelope, User } from "@phosphor-icons/react";
import { Tag as TagIcon } from "@phosphor-icons/react/dist/csr/Tag";
import { useState } from "react";
import { Link } from "react-router-dom";

import { LeadLabels } from "features/labels/components";

import MessageLeadDialog from "common/components/leads/MessageLeadDialog";
import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "common/components/ui/Dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import type { Lead } from "common/types";

import NotesDialog from "./NotesDialog";

import AddNoteIcon from "assets/icons/note-add.svg?react";

export default function LeadMenu({ lead }: { lead: Lead }) {
  const { id } = useSelectedWorkspaceContext();

  const [isLabelsDialogOpen, setIsLabelsDialogOpen] = useState(false);
  const [isNotesDialogOpen, setIsNotesDialogOpen] = useState(false);
  const [isMessageDialogOpen, setIsMessageDialogOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild id="lead-menu-trigger">
          <Button
            variant="secondary-black"
            intent="iconOnly"
            className="ml-auto"
          >
            <DotsThreeVertical />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" id="lead-menu-content">
          <DropdownMenuList>
            <DropdownMenuItem onSelect={() => setIsLabelsDialogOpen(true)}>
              <TagIcon />
              Edit labels
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to={lead.id.toString()} state={{ lead }}>
                <User />
                See profile
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem onSelect={() => setIsNotesDialogOpen(true)}>
              <AddNoteIcon />
              Add note
            </DropdownMenuItem>
            {lead.lead_of.length > 1 ? (
              <DropdownMenuItem onSelect={() => setIsMessageDialogOpen(true)}>
                <Envelope weight="fill" />
                Message lead
              </DropdownMenuItem>
            ) : (
              <DropdownMenuItem asChild>
                <Link
                  to={`/workspaces/${id}/inbox`}
                  state={{ lead: lead, accountId: lead.lead_of[0] }}
                >
                  <Envelope weight="fill" />
                  Message lead
                </Link>
              </DropdownMenuItem>
            )}
          </DropdownMenuList>
        </DropdownMenuContent>
      </DropdownMenu>
      <Dialog open={isLabelsDialogOpen} onOpenChange={setIsLabelsDialogOpen}>
        <DialogContent>
          <DialogTitle className="mb-8">Edit labels</DialogTitle>
          <LeadLabels
            labels={lead.labels}
            profileId={lead.id}
            align="start"
            size="md"
          />
        </DialogContent>
      </Dialog>
      <NotesDialog
        lead={lead}
        isOpen={isNotesDialogOpen}
        onClose={() => setIsNotesDialogOpen(false)}
      />
      <MessageLeadDialog
        lead={lead}
        isOpen={isMessageDialogOpen}
        onClose={() => setIsMessageDialogOpen(false)}
      />
    </>
  );
}
